import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createUsePuck } from '@puckeditor/core';

import ClearableNumberInput from '../Common/ClearableNumberInput';
import RadioField from '../Common/RadioField';
import { normalizePageVisibilityMode } from '../../../../helpers/PageSections';

const usePuckSelector = createUsePuck();

export const GridColumnsField = ({ value, onChange, field }) => {
  const selectedItem = usePuckSelector((s) => s.selectedItem);
  const isGridView = ['grid', 'framed'].includes(selectedItem?.props?.view);

  if (!isGridView) {
    return <div className="puck-feed-columns-hidden" />;
  }

  return (
    <ClearableNumberInput
      value={value}
      onChange={onChange}
      label={field.label}
      min={1}
      max={6}
      step={1}
    />
  );
};

GridColumnsField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

GridColumnsField.defaultProps = {
  value: 3,
};

export const LimitField = ({ value, onChange, field }) => (
  <ClearableNumberInput
    value={value}
    onChange={onChange}
    label={field.label}
    min={1}
    step={1}
  />
);

LimitField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

LimitField.defaultProps = {
  value: 8,
};

export const CollectionFeedDownloadField = ({ value, onChange, field }) => {
  const visibilityMode = usePuckSelector((s) => s.appState?.data?.root?.props?.visibility_mode);
  const isHomepageVisibilityMode = normalizePageVisibilityMode(visibilityMode) === 'homepage';

  useEffect(() => {
    if (isHomepageVisibilityMode && value !== false) {
      onChange(false);
    }
  }, [isHomepageVisibilityMode, onChange, value]);

  if (isHomepageVisibilityMode) {
    return <div className="puck-download-setting-hidden" />;
  }

  return (
    <RadioField
      id="puck-collection-feed-download"
      name="puckCollectionFeedDownload"
      label={field.label}
      value={value}
      onChange={onChange}
      options={field.options}
    />
  );
};

CollectionFeedDownloadField.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
    options: PropTypes.array,
  }).isRequired,
};

CollectionFeedDownloadField.defaultProps = {
  value: true,
};
